module.exports = __webpack_public_path__ + "img/特产店铺8.ad23bce2.png";